import _classCallCheck from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module block-quote/blockquoteediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import BlockQuoteCommand from './blockquotecommand';
/**
 * The block quote editing.
 *
 * Introduces the `'blockQuote'` command and the `'blockQuote'` model element.
 *
 * @extends module:core/plugin~Plugin
 */

var BlockQuoteEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(BlockQuoteEditing, _Plugin);

  var _super = _createSuper(BlockQuoteEditing);

  function BlockQuoteEditing() {
    _classCallCheck(this, BlockQuoteEditing);

    return _super.apply(this, arguments);
  }

  _createClass(BlockQuoteEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor;
      var schema = editor.model.schema;
      editor.commands.add('blockQuote', new BlockQuoteCommand(editor));
      schema.register('blockQuote', {
        allowWhere: '$block',
        allowContentOf: '$root'
      }); // Disallow blockQuote in blockQuote.

      schema.addChildCheck(function (ctx, childDef) {
        if (ctx.endsWith('blockQuote') && childDef.name == 'blockQuote') {
          return false;
        }
      });
      editor.conversion.elementToElement({
        model: 'blockQuote',
        view: 'blockquote'
      }); // Postfixer which cleans incorrect model states connected with block quotes.

      editor.model.document.registerPostFixer(function (writer) {
        var changes = editor.model.document.differ.getChanges();

        var _iterator = _createForOfIteratorHelper(changes),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;

            if (entry.type == 'insert') {
              var element = entry.position.nodeAfter;

              if (!element) {
                // We are inside a text node.
                continue;
              }

              if (element.is('blockQuote') && element.isEmpty) {
                // Added an empty blockQuote - remove it.
                writer.remove(element);
                return true;
              } else if (element.is('blockQuote') && !schema.checkChild(entry.position, element)) {
                // Added a blockQuote in incorrect place - most likely inside another blockQuote. Unwrap it
                // so the content inside is not lost.
                writer.unwrap(element);
                return true;
              } else if (element.is('element')) {
                // Just added an element. Check its children to see if there are no nested blockQuotes somewhere inside.
                var range = writer.createRangeIn(element);

                var _iterator2 = _createForOfIteratorHelper(range.getItems()),
                    _step2;

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var child = _step2.value;

                    if (child.is('blockQuote') && !schema.checkChild(writer.createPositionBefore(child), child)) {
                      writer.unwrap(child);
                      return true;
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
            } else if (entry.type == 'remove') {
              var parent = entry.position.parent;

              if (parent.is('blockQuote') && parent.isEmpty) {
                // Something got removed and now blockQuote is empty. Remove the blockQuote as well.
                writer.remove(parent);
                return true;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return false;
      });
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "afterInit",
    value: function afterInit() {
      var _this = this;

      var editor = this.editor;
      var command = editor.commands.get('blockQuote'); // Overwrite default Enter key behavior.
      // If Enter key is pressed with selection collapsed in empty block inside a quote, break the quote.
      // This listener is added in afterInit in order to register it after list's feature listener.
      // We can't use a priority for this, because 'low' is already used by the enter feature, unless
      // we'd use numeric priority in this case.

      this.listenTo(this.editor.editing.view.document, 'enter', function (evt, data) {
        var doc = _this.editor.model.document;
        var positionParent = doc.selection.getLastPosition().parent;

        if (doc.selection.isCollapsed && positionParent.isEmpty && command.value) {
          _this.editor.execute('blockQuote');

          _this.editor.editing.view.scrollToTheSelection();

          data.preventDefault();
          evt.stop();
        }
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'BlockQuoteEditing';
    }
  }]);

  return BlockQuoteEditing;
}(Plugin);

export { BlockQuoteEditing as default };